<template>
  <div @click.stop="handleClick">
    <input
      :accept="accept"
      :multiple="multiple"
      :picurl="picurl"
      @change="handleChange"
      class="input-style"
      ref="input"
      type="file">
    <slot name="tip"></slot>
  </div>
</template>

<script>

import {
  fileOnlineOssInfo,
  fileUnderlineOssInfo,
  isOnLine,
  onlineOssInfo,
  underlineOssInfo,
  videoOnlineOssInfo,
  videoUnderlineOssInfo
} from '../../config/constantconfig'
import ossupload from '../../utils/fileossupload'

const uuidv1 = require('uuid/v1')

export default {
  name: 'FileUpload',
  props: {
    accept: {
      type: String,
      default: 'image/*'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    canclick: {
      type: Boolean,
      default: true
    },
    picurl: {
      type: String,
      default: 'test/'
    }
  },
  methods: {
    handleClick () {
      if (!this.canclick) {
        return
      }
      this.$refs.input.click()
    },
    handleChange (e) {
      const files = e.target.files
      if (!files) {
        return
      }
      this.uploadFiles(files)
      this.$refs.input.value = null
    },
    uploadFiles (files) {
      let postFiles = Array.prototype.slice.call(files)
      if (!this.multiple) postFiles = postFiles.slice(0, 1)

      if (postFiles.length === 0) return

      let resultarray = []
      let that = this
      this.$emit('uploadstart')
      postFiles.forEach(file => {
        if (this.accept === 'image/*') {
          var reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            var img = new Image()
            img.src = reader.result
            let width = 0
            let height = 0
            if (img.complete) {
              width = img.width
              height = img.height
              that.upload(file).then(res => {
                res.width = width
                res.height = height
                resultarray.push(res)
                let progressdata = {
                  finshnum: resultarray.length,
                  totalnum: postFiles.length,
                }
                that.$emit('uploadprogress', progressdata)
                if (resultarray.length === postFiles.length) {
                  that.$emit('uploadSuccess', resultarray)
                }
              })
            } else {
              img.onload = function () {
                width = img.width
                height = img.height
                that.upload(file).then(res => {
                  res.width = width
                  res.height = height
                  resultarray.push(res)
                  let progressdata = {
                    finshnum: resultarray.length,
                    totalnum: postFiles.length,
                  }
                  that.$emit('uploadprogress', progressdata)
                  if (resultarray.length === postFiles.length) {
                    that.$emit('uploadSuccess', resultarray)
                  }
                })
              }
            }
          }
        } else {
          that.upload(file).then(res => {
            res.width = 0
            res.height = 0
            resultarray.push(res)
            let progressdata = {
              finshnum: resultarray.length,
              totalnum: postFiles.length,
            }
            that.$emit('uploadprogress', progressdata)
            if (resultarray.length === postFiles.length) {
              that.$emit('uploadSuccess', resultarray)
            }
          })
        }
      })
    },
    getUploadPath () {
      let path = 'tradeapp/' + this.picurl
      if (!isOnLine) {
        path = 'image/tradeapp/' + this.picurl
      }
      return path
    },
    getVideoUploadPath () {
      let path = 'tradeapp/' + this.picurl
      return path
    },
    getFileUploadPath () {
      let path = 'tradeapp/' + this.picurl
      if (!isOnLine) {
        path = 'file/tradeapp/' + this.picurl
      }
      return path
    },
    upload (file) {
      let uuid = uuidv1()
      let name = this.getFileSuffix(file.name)
      if (this.accept === 'image/*') {
        let uploadPath = this.getUploadPath()
        return new ossupload.PicOss().multipartUpload(uploadPath + uuid + name, file).then(r1 => {
          let domain = isOnLine ? onlineOssInfo.url : underlineOssInfo.url
          return {
            'oldname': file.name,
            'name': r1.name,
            'url': 'http://' + domain + '/' + r1.url
          }
        }, () => {
          return {
            'oldname': file.name,
            'name': file.name,
            'url': 'error_url'
          }
        })
      } else if (this.accept === 'video/*') {
        let uploadPath = this.getVideoUploadPath()
        return new ossupload.VideoOss().multipartUpload(uploadPath + uuid + name, file).then(r1 => {
          let domain = isOnLine ? videoOnlineOssInfo.url : videoUnderlineOssInfo.url
          return {
            'oldname': file.name,
            'name': r1.name,
            'url': 'http://' + domain + '/' + r1.url
          }
        }, () => {
          return {
            'oldname': file.name,
            'name': file.name,
            'url': 'error_url'
          }
        })
      } else {
        let uploadPath = this.getFileUploadPath()
        return new ossupload.FileOss().multipartUpload(uploadPath + uuid + name, file).then(r1 => {
          let domain = isOnLine ? fileOnlineOssInfo.url : fileUnderlineOssInfo.url

          return {
            'oldname': file.name,
            'name': r1.name,
            'url': 'http://' + domain + '/' + r1.url
          }
        }, () => {
          return {
            'oldname': file.name,
            'name': file.name,
            'url': 'error_url'
          }
        })
      }

    },
    getFileSuffix (name) {
      let resultstr = ''
      let index = name.lastIndexOf('.')
      if (index > 0) {
        resultstr = name.substring(index)
      }
      return resultstr
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-style {
    display: none;
  }
</style>
